import React, { useRef, useState } from "react";
import { StyleSheet, TextInput, View } from "react-native";

import { isDigit } from "utils/common";
import { wp } from "utils/normalise";

const CodeField = ({ isError = false, setOtp = () => {}, otp = ["", "", "", ""] }) => {
    const inputRefs = useRef([]);

    const handleChangeText = (text, index) => {
        if (isDigit(text)) {
            if (text.length === 1) {
                const newOtp = [...otp];
                newOtp[index] = text;
                setOtp(newOtp);
                if (index < 3) {
                    inputRefs.current[index + 1].focus();
                }
            }
        }
    };

    const handleKeyPress = (e, index) => {
        const key = e.nativeEvent.key;
        if (key === "Backspace" || key === "Delete") {
            const newOtp = [...otp];
            if (otp[index] === "" && index > 0) {
                inputRefs.current[index - 1].focus();
            } else {
                newOtp[index] = "";
                setOtp(newOtp);
                if (index > 0 && key === "Backspace") {
                    inputRefs.current[index - 1].focus();
                }
            }
        }
    };

    return (
        <View style={styles.otpContainer}>
            {otp.map((digit, index) => (
                <TextInput
                    key={index}
                    style={[
                        styles.otpInput,
                        {
                            borderColor: isError ? "#CE1A1A" : "#00000029",
                        },
                    ]}
                    keyboardType="number-pad"
                    maxLength={1}
                    value={digit}
                    onChangeText={(text) => handleChangeText(text, index)}
                    onKeyPress={(e) => handleKeyPress(e, index)}
                    ref={(ref) => (inputRefs.current[index] = ref)}
                />
            ))}
        </View>
    );
};

const styles = StyleSheet.create({
    otpContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: wp(333),
    },
    otpInput: {
        borderWidth: 1,
        width: 74,
        height: 74,
        fontSize: 16,
        lineHeight: 24,
        padding: 16,
        textAlign: "center",
        outlineColor: "#212427",
        fontFamily: "JosefinSans",
        color: "#212427",
    },
});

export default CodeField;
